import {PolyNodeDefinition} from './../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDefinition';

//
export interface Dictionary<T> {
	[Key: string]: T;
}
export enum ResponseMessageFromLocalServer {
	NO_USER = 'no user',
	NO_MANIFEST = 'no manifest',
	NO_POLY_CONFIG = 'no poly plugins',
	NO_EDITOR_CONFIG = 'no editor config',
	NO_EDITOR = 'no editor data',
	// NO_EXPORT_TYPE = 'no export type',
	NO_NODE_MODULES = 'no node_modules',
	// NO_ASSETS_CONFIG = 'no assets config, make sure to save your scene',
	NO_LIBS_ROOT = 'no libs root',
	THREEJS_NOT_INSTALLED = 'threejs is not installed',
	XATLAS_NOT_INSTALLED = 'xatlas is not installed',
}
export enum LocalServerUrl {
	ROOT = '/',
	// auth
	TOKEN_CREATE = '/tokens',
	TOKEN_GET = '/token',
	LOGOUT = '/logout',
	// scene
	SCENES = '/scenes',
	SCENE_LOAD = '/scenes/load',
	SCENE_SAVE = '/scenes/save',
	// polyNodes
	POLY_NODES_INDEX = '/poly_nodes',
	POLY_NODE_CREATE = '/poly_nodes/create',
	POLY_NODE_UPDATE = '/poly_nodes/update',
	// marketplace themes
	// MARKETPLACE_TEMPLATE_CREATE = '/marketplace/templates/create',
	// marketplace poly nodes
	MARKETPLACE_POLY_NODES_INDEX = '/marketplace/poly_nodes',
	MARKETPLACE_POLY_NODES_SEARCH = '/marketplace/poly_nodes/search',
	MARKETPLACE_POLY_NODES_DOWNLOAD = '/marketplace/poly_nodes/download',
	MARKETPLACE_POLY_NODES_CREATE = '/marketplace/poly_nodes/create',
	MARKETPLACE_POLY_NODES_ADD_VERSION = '/marketplace/poly_nodes/versions/create',
	// SCENE_EXPORT_ENGINE = '/scenes/engine.json',
	// capture
	CAPTURE_ANIMATION_SAVE = '/captures/animation/save',
	CAPTURE_STATIC_SAVE = '/captures/static/save',
	CAPTURE_STATIC_LOAD = '/captures/static/load',
	// configs
	// EXPORT_TYPE_SAVE = '/export_type/save',
	POLY_CONFIG_LOAD = '/poly_config/load.js',
	EDITOR_CONFIG_LOAD = '/editor_config/load.js',
	// assets
	ASSETS = '/assets.json',
	ASSET_DOWNLOAD = '/assets/download.json',
	// libraries
	INSTALL_DRACO = '/install/draco.json',
	INSTALL_KTX2 = '/install/ktx2.json',
	INSTALL_XATLAS = '/install/xatlas.json',
	// utils
	STATUS = '/utils/status.json',
}
// When the ManifestContent interface is updated
// make sure to sync it with SceneDataManifestImporter
// to allow the engine to load it.
export type ManifestNodesData = Dictionary<string>;
export interface ManifestContent {
	properties: string;
	root: string;
	nodes: ManifestNodesData;
}
export interface CaptureRequestSaveBody {
	sceneName: string;
	fileDataURL: string;
}
export interface CaptureRequestSaveResponse {
	filePath: string;
}
export interface CaptureRequestLoadQuery {
	sceneName: string;
}
export interface CaptureRequestLoadErrorResponse {
	error: string;
}
// export interface ExportTypeRequestBody {
// 	export: SceneExportType;
// }
export interface AssetsRequestQuery {
	extensionsJoined: string;
}
export interface AssetFileData {
	filePath: string;
	timestamp: number;
}
export const TIMESTAMP_URL_PARAM_NAME = 'timestamp';

export interface AssetsRequestResponse {
	error?: string;
	filesData?: AssetFileData[];
}
export interface AssetDownloadRequestBody {
	remoteUrl: string;
}
export interface AssetDownloadRequestResponse {
	localUrl: string;
	timestamp: number;
}

export const ASSETS_EXTENSIONS_SEPARATOR = ',';
export interface LibrariesInstallQuery {
	libsRoot: string;
}
export interface PolyConfigQuery {
	// raw: '0' | '1';
}
// export interface AssetsRequestResponse {
// 	error?: string;
// 	paths?: string[];
// }
export interface ScenesRequestResponse {
	error?: string;
	scenes?: string[];
}
export interface LoadSceneQuery {
	scene: string | null;
}
// export interface ExportSceneQuery {
// 	scene: string;
// 	minify: '0' | '1';
// 	gzip: '0' | '1';
// 	brotli: '0' | '1';
// }
// export interface ExportSceneResponse {
// 	uncompressed: string;
// 	gzip: string;
// 	brotli: string;
// }
export interface SaveResponse {
	warning?: string;
}

export interface LoadSceneResponse {
	manifest?: ManifestContent;
	editor_data?: object;
	root?: object;
	properties?: object;
	ui?: object;
	jsons_by_name?: Dictionary<object>;
	error?: string;
}

export interface LoadDefaultSceneResponse {
	error: string;
	scene: {
		code: object;
		editor: object;
	};
}
export type LoadPolyConfigResponse = string;
export type LoadEditorConfigResponse = Dictionary<string>;

export interface StatusQueryResponse {
	status: string;
}

// export enum SceneExportType {
// 	TYPESCRIPT = 'typescript',
// 	JAVASCRIPT = 'javascript',
// 	HTML = 'html',
// }

//
// POLY NODES
//
export interface PolyNodeMetaData {
	node_context: string;
	node_type: string;
	username?: string;
}
export interface PolyNodeDataRegisterDummy extends PolyNodeMetaData {
	data: PolyNodeDefinition;
}
export interface PolyNodeIndexRequestBody {
	// username: string;
}
export type PolyNodesIndexResponse = PolyNodeDataRegisterDummy[];
export type PolyNodeCreateRequestBody = PolyNodeDataRegisterDummy;
export interface PolyNodeCreateResponse {
	error?: string;
}
export type PolyNodeUpdateRequestBody = PolyNodeDataRegisterDummy;
export interface PolyNodeUpdateResponse {
	error?: string;
}
export interface UserDataResponse {
	username: string;
	pro: boolean;
}

// export type MarketplaceThemeRequestBody = {
// 	name: string;
// };
export interface MyPolyNodeMarketplaceData extends PolyNodeMetaData {
	local: boolean;
	online: boolean;
}
export interface BrowsePolyNodeMarketplaceData extends PolyNodeMetaData {
	version: number;
}
export interface MarketplacePolyNodeIndexRequestBody {
	username: string;
}
export type MarketplacePolyNodeIndexResponseFromLocal = MyPolyNodeMarketplaceData[];
export type MarketplacePolyNodeIndexResponseFromMarket = PolyNodeMetaData[];
export type MarketplacePolyNodeSearchRequestFromEditorBody = {
	q: string;
};
export type MarketplacePolyNodeSearchResponseFromMarket = BrowsePolyNodeMarketplaceData[];
export type MarketplacePolyNodeSearchResponseFromServer = MarketplacePolyNodeSearchResponseFromMarket;

export type MarketplacePolyNodeCreateRequestFromEditorBody = {
	node_context: string;
	node_type: string;
};
export type MarketplacePolyNodeDownloadRequestFromEditorBody = {
	username: string;
	node_context: string;
	node_type: string;
	version: number;
};
export type MarketplacePolyNodeCreateRequestFromServerBody = {
	node_context: string;
	node_type: string;
	data: string;
};
export type MarketplacePolyNodeDownloadRequestFromServerBody = {
	username: string;
	node_context: string;
	node_type: string;
	version: number;
};
export type MarketplacePolyNodeDownloadResponseFromMarket = PolyNodeDefinition;
export type MarketplacePolyNodeDownloadResponseFromLocal = MarketplacePolyNodeDownloadResponseFromMarket;
